import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { errorMessage } from "../../../../utils/notificationUtils";
import { fetchEnhancementDataServiceCghs } from "../../../../apis/SchemeService/CGHS/cghsService";
import ViewResubmissionCghs from "../../../../components/patient/Resubmission/CGHS/ViewResubmissionCghs";
import { errorMessageModal } from "../../../../utils/modalMessage";

type ViewResubmissionContainerCghsProps = {
  viewResubmissionCghs: boolean;
  closeViewResubmissionModal: any;
};

const ViewResubmissionContainerCghs: FC<ViewResubmissionContainerCghsProps> = ({
  viewResubmissionCghs,
  closeViewResubmissionModal,
}) => {
  const { patients } = useSelector((state: RootState) => state);
  const [resubmissionData, setResubmissionData] = useState<any>([]);
  const [isFetchingResubmissionData, setIsFetchingResubmissionData] =
    useState<boolean>(false);

  const fetchResubmissionData = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setIsFetchingResubmissionData(true);
        const res: any = await fetchEnhancementDataServiceCghs(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        );
        if (res && Array.isArray(res)) {
          setResubmissionData(res);
        }
        setIsFetchingResubmissionData(false);
      }
      // Fetch portal meta data
    } catch (error: any) {
      errorMessageModal(error.message || "Please, Try again later");
      setIsFetchingResubmissionData(false);
    }
  };

  useEffect(() => {
    fetchResubmissionData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    viewResubmissionCghs,
  ]);

  return (
    <div>
      <ViewResubmissionCghs
        viewResubmissionCghs={viewResubmissionCghs}
        closeViewResubmissionModal={closeViewResubmissionModal}
        isFetchingResubmissionData={isFetchingResubmissionData}
        resubmissionList={resubmissionData}
      />
    </div>
  );
};

export default ViewResubmissionContainerCghs;
